<template>
	<div class="search-deals">
		<form action="#" method="POST" @submit.prevent="search">
			<div class="inp">
				<input type="text" v-model="keywords" placeholder="Search Listings" />
				<i class="fas fa-search"></i>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	name: "Search",
	data: function() {
		return {
			keywords: ""
		}
	},
	computed: {
		year() {
			return new Date().getFullYear();
		}
	},
	methods: {

		//
		search() {
			this.$router.push({
				name: 'Search',
				query: {
					q: this.keywords.trim()
				}
			});
			this.$emit('searching');
		}

	}
};
</script>

<style lang="scss">
.search-deals {

	.inp {
		position: relative;
		font-size: 16px;
		.fa-search {
			position: absolute;
			top: 10px;
			right: 10px;
			z-index: 10;
			color: #515151;
			font-size: 20px;
		}
	}

	input[type=text] {
		display: block;
		width: 200px;
		height: 42px;
		padding: 0 40px 0 10px;
		line-height: 42px;
		border-radius: 4px;
		border: none;
		background-color: #fff;
		color: #515151;
		-webkit-appearance:none;
	}
}
</style>